import { Field } from "@base-ui/react/field"
import { css } from "dx-styles"
import type { ReactElement } from "react"

import { bodyText, tokens } from "../theme"
import { textRecipe } from "./Text"

export const fieldLabel = css(bodyText, {
  fontWeight: tokens.fontWeight.semibold,
})

export const FieldMessage = ({
  description,
  error,
}: {
  description?: string
  error?: string
}): ReactElement | null => {
  if (error) {
    return (
      <Field.Error
        match
        className={textRecipe({ variant: "danger" })}
      >
        {error}
      </Field.Error>
    )
  }

  if (description) {
    return (
      <Field.Description className={textRecipe({ variant: "description" })}>
        {description}
      </Field.Description>
    )
  }

  return null
}
